<!-- <div class="root-div"> -->
<button
  type="button"
  id="export-button"
  pButton
  pRipple
  (click)="onExportPng()"
  pTooltip="Download report as PNG"
  tooltipPosition="bottom"
  class="p-button-text p-button-plain p-button-lg tool-bar-pbutton icon-top-space-toolbar icon-right-space-toolbar icon-left-space-toolbar">
  <span class="material-symbols-outlined"> download </span>
</button>
<!-- </div> -->
